import { Button, Col, Form, Input, Layout, Row, Typography } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import signinLogo from "../../assets/images/logo-for-logins.png";
import apiPath from "../../constants/apiPath";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";

const { Content } = Layout;

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { request } = useRequest();

  const onSubmit = (values) => {
    const { email } = values;

    if (!email) return ShowToast("Please enter your email!", Severty.ERROR);

    setLoading(true);

    request({
      url: apiPath.forgotPassword, // <-- API endpoint for forgot password
      method: "POST",
      data: { email },
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message || "Password reset link sent!", Severty.SUCCESS);
          navigate("/login"); // redirect to login after request
        } else {
          ShowToast(data.message || "Something went wrong", Severty.ERROR);
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error?.response?.data?.message || "Something went wrong", Severty.ERROR);
      },
    });
  };

  return (
    <div className="main-new-login-page-designe-divv">
      <Layout className="layout-default layout-signin">
        <Content className="signin">
          <Row>
            <Col span={24} lg={24} className="contant-bg-sign">
              <div className="signin-box">
                <div className="signup-logo">
                  <img src={signinLogo} alt="Logo" />
                  <h4>Forgot Your Password?</h4>
                  <p>Enter your email to reset your password</p>
                </div>

                <Form
                  form={form}
                  onFinish={onSubmit}
                  layout="vertical"
                  className="row-col"
                >
                  <Form.Item
                    label="Email Address"
                    name="email"
                    rules={[
                      { required: true, message: "Please enter your email!" },
                      { type: "email", message: "Please enter a valid email!" },
                    ]}
                  >
                    <Input placeholder="Enter your email address" />
                  </Form.Item>

                  <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading} block>
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </Col>
          </Row>
        </Content>
      </Layout>
    </div>
  );
};

export default ForgotPassword;
